import { render } from "./pc_destination_add.vue?vue&type=template&id=9ba9c528&scoped=true"
import script from "./pc_destination_add.vue?vue&type=script&lang=js"
export * from "./pc_destination_add.vue?vue&type=script&lang=js"

import "./pc_destination_add.vue?vue&type=style&index=0&id=9ba9c528&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba9c528"]])

export default __exports__